/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  Perm Address module constants
 */

export const RECEIVE_ACTIVE_LISTINGS = '@@nzr/permanentAddress/RECEIVE_ACTIVE_LISTINGS'

export const RECEIVE_ADDRESS = '@@nzr/permanentAddress/RECEIVE_ADDRESS'

export const RECEIVE_CITY = '@@nzr/permanentAddress/RECEIVE_CITY'

export const RECEIVE_DIL_ADDRESSES = '@@nzr/permanentAddress/RECEIVE_DIL_ADDRESSES'

export const RECEIVE_DIL_BUILDINGS = '@@nzr/permanentAddress/RECEIVE_DIL_BUILDINGS'

export const RECEIVE_INACTIVE_LISTINGS = '@@nzr/permanentAddress/RECEIVE_INACTIVE_LISTINGS'

export const RECEIVE_PET_FRIENDLY_LISTINGS = '@@nzr/permanentAddress/RECEIVE_PET_FRIENDLY_LISTINGS'

export const RECEIVE_HOMES_LISTINGS = '@@nzr/permanentAddress/RECEIVE_HOMES_LISTINGS'

export const RECEIVE_NEIGHBORHOOD = '@@nzr/permanentAddress/RECEIVE_NEIGHBORHOOD'

export const RECEIVE_PRICE_DATA = '@@nzr/permanentAddress/RECEIVE_PRICE_DATA'

export const RECEIVE_HOOD_PRICE_DATA = '@@nzr/permanentAddress/RECEIVE_HOOD_PRICE_DATA'

export const RECEIVE_RENT_HISTORY = '@@nzr/permanentAddress/RECEIVE_RENT_HISTORY'

export const RECEIVE_PET_POLICY = '@@nzr/permanentAddress/RECEIVE_PET_POLICY'

export const SET_PET_FRIENDLY_FETCHING = '@@nzr/permanentAddress/SET_PET_FRIENDLY_FETCHING'

export const SET_HOMES_FETCHING = '@@nzr/permanentAddress/SET_HOMES_FETCHING'

export const SET_MESSAGE_ACTIVE_LISTING_ID =
  '@@nzr/permanentAddress/message/SET_MESSAGE_ACTIVE_LISTING_ID'

export const SET_MESSAGE_LISTING_DETAILS =
  '@@nzr/permanentAddress/message/SET_MESSAGE_LISTING_DETAILS'

export const ERROR_FETCHING_MESSAGE_LISTING_DETAILS =
  '@@nzr/permanentAddress/message/ERROR_FETCHING_MESSAGE_LISTING_DETAILS'

export const START_FETCHING_MESSAGE_LISTING_DETAILS =
  '@@nzr/permanentAddress/message/START_FETCHING_MESSAGE_LISTING_DETAILS'

export const DONE_FETCHING_MESSAGE_LISTING_DETAILS =
  '@@nzr/permanentAddress/message/DONE_FETCHING_MESSAGE_LISTING_DETAILS'

export const RECEIVE_DETAIL_ENTITY = '@@nzr/Detail/RECEIVE_ENTITY'

export const DONE_FETCHING_RENT_HISTORY_DETAIL =
  '@@nzr/permanentAddress/DONE_FETCHING_RENT_HISTORY_DETAIL'
export const ERROR_FETCHING_RENT_HISTORY_DETAIL =
  '@@nzr/permanentAddress/ERROR_FETCHING_RENT_HISTORY_DETAIL'
export const START_FETCHING_RENT_HISTORY_DETAIL =
  '@@nzr/permanentAddress/START_FETCHING_RENT_HISTORY_DETAIL'
export const RECEIVE_RENT_HISTORY_DETAIL = '@@nzr/permanentAddress/RECEIVE_RENT_HISTORY_DETAIL'
